function doesSubscriptionSelected() {
    const result = { subscription: false, amount: 15 };
    const hostElement = document.querySelector('recharge-subscription-widget');
    if (!hostElement || !hostElement.shadowRoot) return result;

    const shadowRoot = hostElement.shadowRoot;
    const subscriptionElement = shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

    if (!subscriptionElement) return result;

    const originalPriceElement = shadowRoot.querySelector(".rc-price.strike-through");
    const salePriceElement = shadowRoot.querySelector(".rc-price:not(.strike-through)");

    if (originalPriceElement && salePriceElement) {
        const originalPrice = parseFloat(originalPriceElement.textContent.replace(/[^0-9.]/g, ""));
        const salePrice = parseFloat(salePriceElement.textContent.replace(/[^0-9.]/g, ""));

        if (!isNaN(originalPrice) && !isNaN(salePrice) && originalPrice > salePrice) {
            result.amount = (((originalPrice - salePrice) / originalPrice) * 100).toFixed(2);
        }
    }

    result.subscription = !subscriptionElement.hasAttribute('rc-not-selected');
    return result;
}

function updateRechargeWidgetPrice(new_price, updateOneTime = true, updateSub = true) {
    const hostElement = document.querySelector('recharge-subscription-widget');
    if (!hostElement || !hostElement.shadowRoot) return;

    const shadow_root = hostElement.shadowRoot;
    if (!shadow_root) {
        return;
    }
    const subscription = shadow_root.querySelector('.rc-purchase-option.rc-purchase-option__subscription');
    if (!subscription) return;
    const price = new_price.trim();
    setTimeout(function () {
        if (updateSub) {
            // Update subscription price
            const subPriceEl = shadow_root.querySelector('.rc-purchase-option__subscription [part="rc-purchase-option__discounted-price"]');
            if (subPriceEl) {
                const nodes = Array.from(subPriceEl.childNodes);
                const textNode = nodes.find(node => node.nodeType === Node.TEXT_NODE && /\$\d+/.test(node.textContent));
                if (textNode) {
                    textNode.textContent = `${new_price}`;
                }
            }
        }

        // Optionally update one-time price
        if (updateOneTime) {
            const oneTimePriceEl = shadow_root.querySelector('.rc-selection__onetime .rc-purchase-option__prices > span.rc-price');
            if (oneTimePriceEl) {
                const nodes = Array.from(oneTimePriceEl.childNodes);
                const textNode = nodes.find(node => node.nodeType === Node.TEXT_NODE && /\$\d+/.test(node.textContent));
                if (textNode) {
                    textNode.textContent = `${price}`;
                }
            }
        }
    }, 200)
}

function isOnScreen(s) {
    if (s.length != 0) {
        var e = jQuery(window),
            t = e.scrollTop(),
            o = e.height(),
            l = t + o,
            n = jQuery(s),
            i = n.offset().top,
            r = n.height(),
            a = i + r;
        return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
    }
}
class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.options = []
        this.updateOptions();
        this.updateMasterId();
        let isDiscountapplied;
        document.addEventListener('subscriptionChange', () => {
            let selling_plan = document.querySelector('product-form input[name="selling_plan"]');
            const selectedVariant = this.currentVariant;
            if (!selectedVariant) {
                return;
            }
            applyDiscountCodePDP();
        })
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.toggleAddButton(true, "", false);
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select"),
            (select) => select.value
        );
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            //   return variant.title === this.querySelector('select').value;
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
        window.currentSelectedVariant = this.currentVariant
        // if (!this.currentVariant) {
        // 	this.currentVariant = this.getVariantData()[0]
        // }
        if (this.currentVariant && document.querySelector(".prodsku")) {
            document.querySelector(".prodsku").innerHTML = "SKU:" + this.currentVariant.sku
        }
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const newMedia = document.querySelector(
            `.js-sp-product-media-slider-desktop [data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        if (!newMedia) return;
        // remove first-image class from all
        document.querySelector(`.js-sp-product-media-slider-desktop .sp-product__media-slide.first-image`).classList.remove('first-image')
        newMedia.classList.add('first-image')
        // We have slick slider on mobile, so we need to update the slider
        const mobileSlider = document.querySelector(`.js-sp-product-media-slider [data-media-id="${this.currentVariant.featured_media.id}"]`)
        if (mobileSlider) {
            if ($('#primary-slider.js-sp-product-media-slider').hasClass('slick-initialized')) {
                $('#primary-slider.js-sp-product-media-slider').slick('slickGoTo', mobileSlider.dataset.slickIndex)
            }
        }
        const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
            `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        modalContent.prepend(newMediaModal);
        parent.prepend(newMedia);
        this.stickyHeader =
            this.stickyHeader || document.querySelector("sticky-header");
        if (this.stickyHeader) {
            this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
        }
        window.setTimeout(() => {
            parent.scrollLeft = 0;
            parent
                .querySelector("li.product__media-item")
                .scrollIntoView({ behavior: "smooth" });
        });
    }

    updateURL() {
        let url = window.location.href;

        // Create a URL object from the current URL
        let urlObj = new URL(url);

        // Update the parameter value
        urlObj.searchParams.set('variant', this.currentVariant.id);
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
            {},
            "",
            `${urlObj.toString()}`
        );
    }

    updateShareUrl() {
        const shareButton = document.getElementById(
            `Share-${this.dataset.section}`
        );
        if (!shareButton) return;
        shareButton.updateUrl(
            `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        // if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        let url = window.location.href;
        let product_info = document.getElementById(`ProductInfo-${this.dataset.section}`);
        if (product_info) {
            product_info.style.pointerEvents = 'none'
        }
        // Create a URL object from the current URL
        let urlObj = new URL(url);

        // Update the parameter value
        urlObj.searchParams.set('variant', this.currentVariant.id);
        fetch(
            `${urlObj.toString()}&section_id=${this.dataset.section}&snippet=snippet1`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
                    const source = html.getElementById(`${id}-${this.dataset.section}`)
                    if (id == 'price') {
                        const destination = document.querySelectorAll(`.pdp-price-wrapper`);
                        if (source && destination.length > 0) {
                            destination.forEach(function (priceInput) {
                                priceInput.innerHTML = source.innerHTML;
                                priceInput.classList.toggle('hidden', shouldHide(source));
                            })
                        }
                    } else {
                        const destination = document.querySelector(`#${id}-${this.dataset.section}`);
                        if (source && destination) {
                            destination.innerHTML = source.innerHTML;
                            destination.classList.toggle('hidden', shouldHide(source));
                        }
                    }
                };

                updateSourceFromDestination('price');
                // updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
                updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
                updateSourceFromDestination('variant');
                // updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
                // observeRecharge();

                document.dispatchEvent(new Event("subscriptionChange", { bubbles: true }))
                if (this.currentVariant) {
                    this.toggleAddButton(
                        !this.currentVariant.available,
                        window.variantStrings.soldOut
                    );
                }
                if (product_info) {
                    product_info.style.pointerEvents = ''
                }
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const newATCBtn = productForm.querySelector(".new-atc__button");
        const newAddButton = productForm.querySelector(".button_text");
        const stickyAtcBtns = document.querySelectorAll(".js-sticky-atc-btn");

        if (!addButton) return;
        if (disable) {
            newATCBtn.setAttribute("disabled", "disabled");
            addButton.setAttribute("disabled", "disabled");
            if (text) {
                addButtonText.textContent = text;
                newAddButton.textContent = text;
                stickyAtcBtns.forEach((btn) => {
                    btn.setAttribute("disabled", "disabled");
                    btn.textContent = text;
                })
            }
        } else {
            newATCBtn.classList.remove('hidden')
            newATCBtn.removeAttribute("disabled");
            addButton.removeAttribute("disabled");
            if (newATCBtn.classList.contains('preorder')) {
                addButtonText.textContent = 'PRE ORDER';
                newAddButton.textContent = 'PRE ORDER';
                stickyAtcBtns.forEach((btn) => {
                    btn.removeAttribute("disabled");
                    btn.textContent = 'PRE ORDER';
                })
            } else {
                addButtonText.textContent = window.variantStrings.addToCart;
                newAddButton.textContent = window.variantStrings.addToCart;
                stickyAtcBtns.forEach((btn) => {
                    btn.removeAttribute("disabled");
                    btn.textContent = window.variantStrings.addToCart;
                })
            }

        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(
            `product-form-${this.dataset.section}`
        );
        const newATCBtn = button.querySelector(".new-atc__button");
        const newAddButton = newATCBtn.querySelector(".button_text");
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        newAddButton.textContent = window.variantStrings.unavailable;
        const stickyAtcBtns = document.querySelectorAll(".js-sticky-atc-btn");

        stickyAtcBtns.forEach((btn) => {
            btn.setAttribute("disabled", "disabled");
            btn.textContent = window.variantStrings.unavailable;
        })
        //if (price) price.classList.add("visibility-hidden");
    }

    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
                input.disabled = false;
            } else {
                input.classList.add('disabled');
                input.disabled = true;
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find(
                (radio) => radio.checked
            ).value;
        });
    }
}

customElements.define("variant-radios", VariantRadios);
document.addEventListener("DOMContentLoaded", function () {
    let prodSupport = document.querySelector('.open-support-chat')
    if (prodSupport) {
        prodSupport.addEventListener("click", function (event) {
            event.preventDefault();
            if (window.GorgiasChat) {
                window.GorgiasChat.open()
            }
        })
    }
    
    // PDP Add On product slider start
    if ($('.js-sp-product-add-on-slider').length > 0) {
        $('.js-sp-product-add-on-slider').slick({
            slidesToShow: 3.85,
            slidesToScroll: 1,
            dots: false,
            infinite: false,
            prevArrow: `<button type="button" class="slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.5,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }
    // PDP Add On product slider end

    // AD Product Gallery Slider Start
    if ($(".js-sp-product-gallery-slider").length > 0) {
        $('.js-sp-product-gallery-slider').slick({
            focusOnSelect: true,
            // variableWidth: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            prevArrow: `<button type="button" class="sp-slick-arrow sp-slick-prev slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="sp-slick-arrow sp-slick-next slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.35,
                        infinite: false
                    }
                }
            ]
        });
        // AD Product Gallery Slider End
    }

    // AD Product Video slider Start
    function playVideo(element) {
        let videoContainer = element.closest(".js-sp-video-main-video");
        videoContainer.classList.add("is--active");

        let video = videoContainer.querySelector("video");
        video.play();

        // Remove any existing volumechange listener before adding a new one
        video.removeEventListener("volumechange", muteHandler);
        video.addEventListener("volumechange", muteHandler);
    }

    // Define the mute handler function separately
    function muteHandler(event) {
        event.target.muted = true;
    }

    function pauseVideo(element) {
        element.closest(".js-sp-video-main-video").classList.remove("is--active")
        element.closest(".js-sp-video-main-video").querySelector("video").pause();
    }

    let $slider = $('.js-sp-video-main-slider');
    let $progressBar = $('.js-sp-video-slider-progressbar');
    let $progressBarLabel = $('.js-sp-video-slider-progressbar-label');

    if ($slider.length > 0) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.js-sp-video-nav-slider',
            infinite: false
        })
        $('.js-sp-video-nav-slider').slick({
            // dots: true,
            infinite: false,
            vertical: true,
            verticalSwiping: true,
            asNavFor: '.js-sp-video-main-slider',
            slidesToShow: 5,
            slidesToScroll: 1,
            focusOnSelect: true,
            prevArrow: `<button type="button" class="sp-slick-arrow sp-slick-prev slick-prev" aria-label="Click to see previous slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.229 16.132L5.59696 10.5L11.229 4.86797" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            nextArrow: `<button type="button" class="sp-slick-arrow sp-slick-next slick-next" aria-label="Click to see next slide"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.42371 4.86807L11.0557 10.5001L5.42371 16.1322" stroke="#161616" stroke-width="1.15672" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        vertical: false,
                        verticalSwiping: false
                    }
                }
            ]
        });

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

            $progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc);

            $progressBarLabel.text(calc + '% completed');
        });
        $slider.on('afterChange', function (event, slick, currentSlide) {
            const mainSlides = document.querySelectorAll(".sp-video__main-slide");
            mainSlides.forEach(function (element, index) {
                if (currentSlide === index) {
                    playVideo(element.querySelector(".js-sp-video-main-video-btn"));
                }
                if (currentSlide !== index && element.querySelector(".js-sp-video-main-video").classList.contains("is--active")) {
                    pauseVideo(element.querySelector(".js-sp-video-main-video-btn"));
                }
            })
        });
        // AD Product Video slider End

        // AD Product Video Play Pause Start
        const videoBtn = document.querySelectorAll(".js-sp-video-main-video-btn");
        videoBtn.forEach(function (btn) {
            btn.addEventListener("click", function () {
                playVideo(this);
            })
        })

        // Get all video elements in the slider
        const advideos = document.querySelectorAll('.sp-video__main-slider video');

        // Add an 'ended' event listener to each video
        advideos.forEach((video) => {
            video.addEventListener('ended', function () {
                // Get the current slide index
                const currentSlide = $slider.slick('slickCurrentSlide');

                // Check if the current slide is the last one
                if (currentSlide === advideos.length - 1) {
                    return;
                }
                $slider.slick('slickNext');
            });
        });
        // AD Product Video Play Pause End
    }

    /* scroll to target */
    jQuery('.scrollTo').click(function (e) {
        let jump = '#' + jQuery(this).data('anchor');
        let new_position = jQuery(jump).offset();
        let scroll = 0;
        let header_height = jQuery('header.header').height();
        if (jQuery('.sp-product-nav-shopify-section').hasClass('sticky')) {
            header_height = jQuery('.sp-product-nav-shopify-section').height();
        }

        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll - header_height }, 800, function () {
            let new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll - header_height }, 800);

        });
        e.preventDefault();
    });

    const sections = document.querySelectorAll(".section-to-track");
    const navLinks = document.querySelectorAll(".sp-product-nav__list-item");
    const navBarLinks = document.querySelector('.sp-product-nav');
    if (document.body.classList.contains('sp-product-page') && navLinks.length > 0) {
        // Function to determine the active section
        const setActiveLink = () => {
            let activeSectionFound = false;

            // Loop through all sections to find the one in view
            sections.forEach((section, index) => {
                const rect = section.getBoundingClientRect();
                // Check if the section is in the viewport
                if (rect.top <= 150 && rect.bottom >= 150) {
                    // Remove active class from all links
                    navLinks.forEach((link) => {
                        if (section.id !== link.dataset.anchor) {
                            link.classList.remove("active")
                        } else {
                            link.classList.add("active");
                            activeSectionFound = true;
                            scrollToActiveNavItem(link);
                        }
                    });
                }
            });

            // If no section is in view, remove the active class from all links
            let navbarVisible = true;
            if (navBarLinks) {
                navbarVisible = false
                const rectNav = navBarLinks.getBoundingClientRect();
                if (rectNav.top <= 150 && rectNav.bottom >= 150) {
                    navbarVisible = true
                }
            }

            if (!activeSectionFound && navbarVisible) {
                navLinks.forEach((link) => link.classList.remove("active"));
            }
        };
        // Function to scroll the active nav item into view
        const scrollToActiveNavItem = (activeItem) => {
            const navList = document.querySelector(".sp-product-nav__list");
            if (navList && activeItem) {
                navList.scrollTo({
                    left: activeItem.offsetLeft - navList.offsetWidth / 2 + activeItem.offsetWidth / 2,
                    behavior: "smooth"
                });
            }
        };
        // Debounced version of setActiveLink
        const debouncedSetActiveLink = debounce(setActiveLink, 100); // 100ms delay

        // Attach scroll event listener with debouncing
        window.addEventListener("scroll", debouncedSetActiveLink);

        // Initialize on page load
        setActiveLink();
    }

    if ($(".non-sticky-atc-button").length > 0) {
        isOnScreen($(".non-sticky-atc-button").eq(0))
            ? $(".sticky-atc-button").fadeOut(100).removeClass("is--active")
            : $(".sticky-atc-button").fadeIn(100).addClass("is--active"),
            $(window).on("scroll", function () {
                isOnScreen($(".non-sticky-atc-button").eq(0))
                    ? $(".sticky-atc-button").fadeOut(10).removeClass("is--active")
                    : $(".sticky-atc-button").fadeIn(10).addClass("is--active");
            })
    }
});